// src/padplanner/SidePanel.jsx
//
// The mockups' left panel: 370px, full height, a fixed head, a body that
// scrolls, and an optional footer that stays put (New plan's Cancel / Create).
// The list, New plan and the plan page all sit in one; the map takes the rest.
//
// Head and footer are shrink-0: in a short window only the body gives up
// height (it scrolls), so the head's actions and the footer's buttons are
// never squeezed or clipped.
export default function SidePanel({ head, children, footer = null, label }) {
  return (
    <aside className="flex h-full w-[370px] shrink-0 flex-col border-r border-bg-border bg-bg-soft" aria-label={label}>
      {head && <div className="flex shrink-0 flex-col gap-3 border-b border-bg-border px-4 pb-3 pt-4">{head}</div>}
      <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-auto px-4 py-4">{children}</div>
      {footer && <div className="flex shrink-0 items-center justify-end gap-2 border-t border-bg-border px-4 py-3">{footer}</div>}
    </aside>
  );
}

/** op-label, upper case: the mockups' small mono section headings. */
export function SectionLabel({ children, id }) {
  return <div id={id} className="op-label uppercase">{children}</div>;
}
